import * as types from "./../types";

export const loading = bool => {
  return dispatch =>
    dispatch(
      bool
        ? {
            type: types.SHOW_LOADER
          }
        : {
            type: types.HIDE_LOADER
          }
    );
};
